<div #chartContainer class="relative h-full w-full">
  @if (options) {
    <div
      echarts
      [options]="options"
      class="h-full w-full"
      (chartInit)="onChartInit($event)"
      (chartClick)="onChartClick($event)"
    ></div>
  } @else {
    <div class="flex h-full w-full items-center justify-center text-[13px] font-medium text-dim">
      Awaiting KPI data
    </div>
  }
</div>
